

export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://jxc.doylear.space";
 

const endpoints = {
  ADDSTORY: "/api/Tiezi/setTiezi",
  GETSTORYLIST: "/api/Tiezi/getTiezilist",
  UPLOAD: "/api/common/upload",
  UPGRADE: "/api/Tiezi/getTiezi",
  DELETE: "/api/Tiezi/delTiezi",
  GETREVIEWSLIST: "/api/Pinglun/getPinglunlisttiezi",
  ADDREVIEW: "/api/Pinglun/setPinglun",
  PIXEL: "https://www.hugfb.com/api/Urlrelation/getUrlrelationUrl",
  FACEBOOK: "/api/facebook/EventsAll",
  PAYMENT: "/api/order/index",
  PAYMENT1: "/api/order/index1",
  PAYMENT2: "/api/order/index2",
  GETPK: "/api/order/get_pk",
  GET_URL: "/api/order/get_url",
  SUCCESS: "/api/order/customstatus",
  GETTIEZI: "/api/Tiezi/getTiezilist",
  GETPINGLUN: "/api/Pinglun/getPinglunlisttiezi",
  ADDRESS: "/api/order/address",
  GET_ORDER: "/api/order/getOrderInfoByOrderNo",
  GET_ORDER_LIST: "/api/order/get_order_list",
  SEND_EMAIL_TO_CLIENT: "https://www.hsmail.vip/api/External/SingleEmailSend",
  SENDMESSAGE: "/api/order/send_kf_2",

  GETPRODUCTLIST: "/api/Product/getProductList", //获取商品列表
  ADDMODIFYPRODUCT: "/api/Product/setProduct", //新增修改产品
  SEARCHPRODUCTBYID: "/api/Product/getProduct", //根据id查看商品
  UPDOWNPRODUCT: "/api/Product/listinganddelistingProducts", //上架下架商品
  DELETEPRODUCT: "/api/Product/delProduct", //删除商品

  GETCATEGORYLIST: "/api/Category/getCategoryList", //获取分类列表分页
  SETCATEGORY: "/api/Category/setCategory", //新增修改分类
  GETCATEGORYBYID: "/api/Category/getCategory", //根据id查看分类
  DELETECATEGORY: "/api/Category/delCategory", //根据id删除分类

  UPLOAD_CHUNK: "/api/Uploadzip/upload_chunk", //上传图片分片
  MERGE_AND_ZIP: "/api/Uploadzip/merge_and_zip", //合并分片并压缩
  SEARCHUPLOAD: "/api/common/searchupload", //上传图片进行搜索
  LOGINOUT: "/api/Denglu/logout", //登出
  LOGIN: "/api/Yonghu/login", //登录
  ADDUSER: "/api/Yonghu/setYonghu", //新增修改用户

  ORDERLIST: "/api/Order/getOrderList", //订单列表分页
  SEARCHPORDERBYID: "/api/Order/getOrder", //根据id查看order
  ADDORDER: "/api/Order/setOrder", //新增订单
  UPORDER: "/api/Order/upOrderStatus", //修改订单状态
};

export default endpoints;
